import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex, Row } from 'Components/UI'

export const Container = styled(Flex).attrs({
  px: [3, 24],
  py: [2, 0],
})`
  position: relative;
  display: flex;
  min-height: 64px;
  width: 100%;
  align-items: center;
  overflow: hidden;
  border-radius: 8px;
  border: solid 1px ${themeGet('colors.softPeach')};
  transition: ${themeGet('transition')};

  :hover {
    border: solid 1px ${themeGet('colors.primary')};
  }
`

export const Content = styled.div`
  display: flex;
  align-items: center;
`

export const ImageHolder = styled(Row)`
  width: 20px;
  min-width: 20px !important;
  height: 20px;
  overflow: hidden;

  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
`
